module.exports = __webpack_public_path__ + "img/black-text.1345c1c2.png";